document.addEventListener('DOMContentLoaded',function() {

    const cover = document.getElementById('cover');
    
    
    
    const init = function() {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        
        if (document.getElementsByClassName('anim').length>0) {
            window.inViewInit();
        }
        
        document.getElementsByClassName('js-player').length > 0 ? window.videoInit() : false;
        
     
        // Detect url params
        const queryString = window.location.search;
        
        if (queryString) {
            const urlParams = new URLSearchParams(queryString),
                  target = urlParams.get('target'),
                  offset = urlParams.get('offset');
            
            if (target != null && offset != null) {
                window.runScroll( '#'+target, offset ) 
            }
        }
        

        setTimeout(function() {
            window.anims();
            window.carousels();
            document.getElementById('facts') ? window.facts() : false;
            cover.remove();

            history.pushState("", document.title, window.location.pathname + window.location.search);
        }, 250);  
    };
    
    window.addEventListener('load', init);
}, false);